import {
  setError,
  setLoading,
  setLogout,
  setUserLogin,
} from "../../features/auth/authLoginSlice";
import { updateLastActivity } from "../../features/auth/idleSlice";
import { getUserDetails, setSession } from "../../common/utils";
import http from "../../common/cticApi";
import CryptoJS from "crypto-js";
import authClient from "./OktaAuthConfig";
import { setMultipleFirmsUser } from "../../features/lawFirm/lawFirmSlice";

export const loginUserWithOkta =
  (accessToken, idToken, toast) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let requestData = {
        OktaAccessToken: accessToken,
      };

      let url = window?.__ENV?.USER_LOGIN_URL;
      let { data: response } = await http.post(url, requestData);

      if (response.responseCode == 0) {
        dispatch(setUserLogin(response.responseObject));
        dispatch(updateLastActivity());
        setSession();
        localStorage.setItem(
          "userInfo",
          CryptoJS.AES.encrypt(
            JSON.stringify({ ...response.responseObject, idToken }),
            process.env.REACT_APP_CRYPTO_KEY,
          ).toString(),
        );
      } else {
        dispatch(setError(response.responseDescription));
        toast.error("User is not registered");
        await authClient.signOut({
          postLogoutRedirectUri: window.location.origin,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
      toast.error("User is not registered, redirecting...", {
        position: "top-center",
        autoClose: 7000,
        closeOnClick: true,
        draggable: true,
        style: {
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          maxWidth: "600px",
          textAlign: "center",
        },
      });
      setTimeout(() => {
        authClient.signOut({
          postLogoutRedirectUri: window.location.origin,
        });
      }, 3000);
    }
  };
export const logoutUserWithOkta = () => async (dispatch) => {
  window.localStorage.removeItem("session");
  window.localStorage.removeItem("userInfo");
  window.localStorage.removeItem("dashboardLawFirm");
  window.localStorage.removeItem("selectedFirmId");
  dispatch(setLogout());
  await authClient.signOut({
    postLogoutRedirectUri: window.location.origin,
  });
  // window.location.replace(
  //   `https://fnfcanada.oktapreview.com/oauth2/auslvfiaznQOmx8Ns1d7/v1/logout?id_token_hint=${obj?.idToken}&post_logout_redirect_uri=${window.location.origin}`
  // );
};
